import { render, staticRenderFns } from "./modalAddBusinessEvent.vue?vue&type=template&id=221d29d6&scoped=true&"
import script from "./modalAddBusinessEvent.vue?vue&type=script&lang=js&"
export * from "./modalAddBusinessEvent.vue?vue&type=script&lang=js&"
import style0 from "./modalAddBusinessEvent.vue?vue&type=style&index=0&id=221d29d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d29d6",
  null
  
)

export default component.exports